import React from "react";
import PremiumBackLink from "./PremiumBackLink";

export default function OrderActions({
  dirty,
  busy,
  save,
  onNext,
  nextLabel = "Zapisz i przejdź dalej",
  backTo,
  backLabel = "Poprzedni krok",
}) {
  if (busy) return null;
  return (
    <nav
      className="premium-step-navigation"
      aria-label="Nawigacja między krokami świadectwa"
    >
      {backTo && <PremiumBackLink to={backTo} destination={backLabel} />}
      {dirty && <span className="text-muted">Masz niezapisane zmiany.</span>}
      {save && (
        <button
          type="button"
          className="btn btn-outline-primary"
          onClick={save}
        >
          Zapisz wersję roboczą
        </button>
      )}
      <button
        type="button"
        className="btn btn-primary"
        onClick={onNext}
      >
        {nextLabel}
      </button>
    </nav>
  );
}
